<i18n src="@/locales/components/TimeRepeaterTranslate.json"></i18n>
<i18n src="@/locales/components/CbsSelectMonthTranslate.json"></i18n>

<template>
	<div class="time-repeater">
		<!-- Choose Type repeat and period -->
		<div class="due-time-container flex items-center">
			<h6 class="mb-2 custom-component--title">{{ $t("Period") }}:</h6>
			<div class="">
				<div class="flex items-center">
					<el-select :clearable="!isEnableRepeater" class="w-3/6 border-none mx-2" v-model="localRepeater.freq" :placeholder="`${$t('Actions.Choose')} ${$t('Period').toLowerCase()}`">
						<el-option v-for="item in choices" :key="item.value" :label="`Theo ${item.text}`" :value="item.value"> </el-option>
					</el-select>
					<p class="">{{ $t("Each") }}</p>
					<div class="">
						<cbs-input
							v-model="localRepeater.interval"
							class="w-auto block mx-2"
							name="interval"
							dataType="int"
							v-validate="{
								required: true,
								regex: '^[1-9]\\d*$'
							}"
							:data-vv-as="`${$t('Placeholder.Interval')} ${$t('Period').toLowerCase()}`"
							:placeholder="`${$t('Placeholder.Interval')}`"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('interval')">{{ errors.first("interval") }}</span>
					</div>

					<p>
						{{ $t(`Repeater.${localRepeater.freq}`).toLowerCase() }}
					</p>
				</div>
			</div>
		</div>

		<!-- Choose day of week -->
		<div v-if="localRepeater.freq === 'weekly'" class="mt-6 time-repeater--select-byhour time-repeater--select-days-week ">
			<h6 class="mb-2 custom-component--title">{{ $t("Label.DaysRepeater") }} <span class="text-danger">*</span>:</h6>

			<div class="time-repeater--select-days-week flex justify-start">
				<vs-checkbox v-model="localRepeater.byday" v-for="(item, idx) in daysOfTheWeek" :vs-value="item.value" :key="idx" class="mr-2">
					{{ item.label }}
				</vs-checkbox>
			</div>
			<span class="text-danger text-sm break-normal" v-show="errors.has('day-repeat')">{{ errors.first("day-repeat") }}</span>
		</div>

		<!-- Yearly config -->
		<yearly-config-repeat v-model="localYearlyRepeater" v-if="localRepeater.freq === 'yearly'" class="mt-6 time-repeater__yearly-config" />

		<!-- Monthly config -->
		<monthly-config-repeat v-model="localMonthlyRepeater" v-if="localRepeater.freq === 'monthly'" class="mt-6 time-repeater__monthly-config" />

		<!-- Choose time at day -->
		<div v-if="localRepeater.freq !== 'hourly'" class="mt-6 time-repeater--select-byhour flex items-baseline">
			<h6 class="mb-2 custom-component--title mr-2">{{ $t("Label.HourRepeat") }}:</h6>
			<CbsMultiDate type="time" v-model="localRepeater.by_fixed_times" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('hour-repeat')">{{ errors.first("hour-repeat") }}</span>
		</div>

		<!-- Description -->
		<div class="bg-gray-6 px-2 py-3 mt-6" v-if="localRepeater.freq && localRepeater.interval">
			<span v-if="localRepeater.dtstart">
				{{ $t("Since") }} {{ localRepeater.dtstart | dateTime(userDateTimeFormat) }}, {{ $t("RepeaterBy").toLowerCase() }} {{ localRepeater.interval }}
				{{ $t(`Repeater.${localRepeater.freq}`) }}
				1 {{ $t("Times") }}
			</span>
			<span v-else>
				{{ $t("RepeaterBy") }} {{ localRepeater.interval }}
				{{ $t(`Repeater.${localRepeater.freq}`).toLowerCase() }}
				1 {{ $t("Times") }}
			</span>
			<span v-if="localRepeater.byday && localRepeater.byday.length > 0 && localRepeater.freq === 'weekly'">
				{{ $t("At") }} <span v-for="(item, key) in localRepeater.byday" :key="key">{{ $t(`DaysOfTheWeek.${item}`) }}<span v-if="key !== localRepeater.byday.length - 1">, </span></span>
			</span>
			<span v-if="localRepeater.byday && typeof localRepeater.byday === 'string' && (localRepeater.freq === 'yearly' || localRepeater.freq === 'monthly')">
				{{ $t("At") }}
				<span v-for="(item, key) in localRepeater.byday.split(',')" :key="key">{{ $t(`DaysOfTheWeek.${item}`) }}<span v-if="key !== localRepeater.byday.split(',').length - 1">, </span></span>
			</span>
			<span v-if="localRepeater.bysetpos && localRepeater.byday && (localRepeater.freq === 'yearly' || localRepeater.freq === 'monthly')">
				&nbsp;{{ $t("TypeRepeater.Weekly").toLowerCase() }} {{ $t(`SetPos.${$options.filters.filterSetPos(localRepeater.bysetpos)}`).toLowerCase() }}
				<span v-if="localRepeater.freq === 'monthly'">
					{{ $t("OfMonth") }}
				</span>
			</span>
			<span v-if="localRepeater.bysetpos && localRepeater.byday && localRepeater.bymonth">
				&nbsp;{{ $t("Of") }} {{ $t(`${$options.filters.filterMonth(localRepeater.bymonth)}`).toLowerCase() }}
			</span>
			<span v-if="localRepeater.bymonthday && localRepeater.bymonth && localRepeater.freq === 'yearly'">
				{{ $t("At") }} {{ $t("Time.day") }} {{ localRepeater.bymonthday }} {{ $t(`${$options.filters.filterMonth(localRepeater.bymonth)}`).toLowerCase() }}
			</span>
			<span v-if="localRepeater.bymonthday && localRepeater.bymonth === null"> {{ $t("At") }} {{ $t("Time.day") }} {{ localRepeater.bymonthday }} </span>
			<span v-if="localRepeater.byhour && localRepeater.byhour.length > 0 && localRepeater.freq !== 'hourly'">
				, {{ $t("AtTime") }} <span v-for="(hour, inx) in localRepeater.byhour" :key="hour">{{ hour }}:00<span v-if="inx !== localRepeater.byhour.length - 1">, </span></span>
			</span>
			<span v-if="localRepeater.by_fixed_times && localRepeater.by_fixed_times.length > 0 && localRepeater.freq !== 'hourly'">
				, {{ $t("AtTime") }} <span v-for="(hour, inx) in localRepeater.by_fixed_times" :key="hour">{{ hour }}<span v-if="inx !== localRepeater.byhour.length - 1">, </span></span>
			</span>

			<span>.</span>
		</div>
	</div>
</template>

<script>
import * as _ from "lodash";

import vSelect from "vue-select";
import { Validator } from "vee-validate";
import YearlyConfigRepeat from "./YearlyConfigRepeat";
import MonthlyConfigRepeat from "./MonthlyConfigRepeat";
import CbsMultiDate from "@/components/cbs-multi-date/CbsMultiDate.vue";

const dict = {
	custom: {
		interval: {
			regex: "Số chu kỳ phải là số nguyên lớn hơn hoặc bằng 1"
		}
	}
};
Validator.localize("vi", dict);
const isValidData = timrepeater => _.has(timrepeater, "freq") && _.has(timrepeater, "byday") && _.has(timrepeater, "bymonthday") && _.has(timrepeater, "interval") && _.has(timrepeater, "dtstart");

export default {
	inject: ["parentValidator"],
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => isValidData(prop)
		},
		isEnableRepeater: {
			type: Boolean,
			default: false
		}
	},
	components: {
		vSelect,
		YearlyConfigRepeat,
		MonthlyConfigRepeat,
		CbsMultiDate
	},
	data() {
		return {
			choices: [
				{
					value: "hourly",
					text: this.$t("TypeRepeater.Hourly")
				},
				{
					value: "daily",
					text: this.$t("TypeRepeater.Daily")
				},
				{
					value: "weekly",
					text: this.$t("TypeRepeater.Weekly")
				},
				{
					value: "monthly",
					text: this.$t("TypeRepeater.Monthly")
				},
				{
					value: "yearly",
					text: this.$t("TypeRepeater.Yearly")
				}
			],

			daysOfTheWeek: [
				// { label: this.$t("All"), value: "all" },
				{ label: this.$t("DaysOfTheWeek.MO"), value: "MO" },
				{ label: this.$t("DaysOfTheWeek.TU"), value: "TU" },
				{ label: this.$t("DaysOfTheWeek.WE"), value: "WE" },
				{ label: this.$t("DaysOfTheWeek.TH"), value: "TH" },
				{ label: this.$t("DaysOfTheWeek.FR"), value: "FR" },
				{ label: this.$t("DaysOfTheWeek.SA"), value: "SA" },
				{ label: this.$t("DaysOfTheWeek.SU"), value: "SU" }
			],

			optionsByHour: [-1, ...Array(24).keys()],
			selectedDaysOfWeek: []
		};
	},
	methods: {
		triggerClickDatetimePicker() {
			this.$refs.dtimePickerRef.$children[0].pickerVisible = true;
		},
		changeByDay(selected) {
			if (selected.includes("all") && selected.length === 1) {
				this.localRepeater.byday = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
			}

			if (selected.includes("all") && selected.length > 1) {
				this.localRepeater.byday = [];
			}
		}
	},

	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	},
	watch: {
		"localRepeater.freq": {
			handler: function(newVal, oldVal) {
				if (newVal === null) {
					this.localRepeater = {
						byday: [],
						byhour: [],
						by_fixed_times: [],
						dtstart: null
					};
				}

				if (oldVal !== newVal) {
					if (newVal === "monthly") {
						this.localRepeater = {
							...this.localRepeater,
							bymonth: null,
							byday: ""
						};
					}
					if (newVal === "weekly") {
						this.localRepeater = {
							...this.localRepeater,
							bymonth: null,
							byday: [],
							bymonthday: ""
						};
					}
				}
			},
			deep: true
		}
	},
	computed: {
		localRepeater: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localYearlyRepeater: {
			get() {
				return {
					byday: Array.isArray(this.localRepeater.byday) ? this.localRepeater.byday.join(",") : this.localRepeater.byday,
					bymonth: this.localRepeater.bymonth,
					bysetpos: this.localRepeater.bysetpos,
					bymonthday: this.localRepeater.bymonthday
				};
			},
			set(val) {
				this.localRepeater = {
					...this.localRepeater,
					...val
				};
			}
		},
		localMonthlyRepeater: {
			get() {
				return {
					byday: this.localRepeater.byday,
					bysetpos: this.localRepeater.bysetpos,
					bymonthday: this.localRepeater.bymonthday
				};
			},
			set(val) {
				this.localRepeater = {
					...this.localRepeater,
					...val
				};
			}
		}
	},
	filters: {
		filterSetPos(setPosVal) {
			switch (Number(setPosVal)) {
				case 1:
					return "First";
				case 2:
					return "Second";
				case 3:
					return "Third";
				case 4:
					return "Fourth";
				case -1:
					return "Last";
				default:
					return "";
			}
		},
		filterMonth(monthVal) {
			const monthObj = {
				1: "Jan",
				2: "Feb",
				3: "Mar",
				4: "Apr",
				5: "May",
				6: "Jun",
				7: "Jul",
				8: "Aug",
				9: "Sep",
				10: "Oct",
				11: "Nov",
				12: "Dec"
			};
			return monthObj[Number(monthVal)] || "";
		}
	}
};
</script>

<style lang="scss">
.time-repeater--select-byhour,
.time-repeater__yearly-config,
.time-repeater__monthly-config {
	.el-tag.el-tag--info {
		background-color: var(--color-solid-primary);
		border-color: var(--color-solid-primary);
		color: #fff;
	}
	.el-select .el-tag__close.el-icon-close {
		background-color: transparent;
		color: #fff;
	}
}
.time-repeater {
	.due-time-content {
		.el-input__inner {
			border-right: none !important;
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
		.vs-input-primary {
			.vs-con-input {
				input {
					// border-left: none !important;
					border-top-left-radius: 0;
					border-bottom-left-radius: 0;
				}
			}
		}
	}
}
.time-repeater--select-days-week {
	.con-vs-checkbox {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		box-sizing: border-box;
		.vs-checkbox {
			// display: none;
		}
	}
	.con-vs-checkbox .vs-checkbox {
		// display: none;
		position: absolute;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		border: 0.5px solid #bdbdbd !important;
	}
	.vs-checkbox-primary input:checked + .vs-checkbox {
		position: absolute;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: var(--color-solid-primary);
	}
	.vs-checkbox-primary input:checked + .vs-checkbox + .con-slot-label {
		color: #fff;
		z-index: 9;
	}
	.vs-checkbox--input:checked + .vs-checkbox .vs-icon {
		display: none;
	}
	.con-vs-checkbox .con-slot-label {
		margin-left: 0;
		width: 100%;
		text-align: center;
	}
}
</style>
